
import { defineComponent, ref, computed, PropType } from "vue";
// components
import DeleteConfirmationModal from "@/components/modals/DeleteConfirmationModal.vue";
// store
import useScheduleStore from "@/store/useScheduleStore";
// other
import { Schedule } from "@/graphql/types";

export default defineComponent({
  name: "ScheduleDeleteButton",
  components: {
    DeleteConfirmationModal
  },
  props: {
    schedule: { type: Object as PropType<Schedule>, required: true }
  },
  emits: {
    deleted: null,
    canceled: null
  },
  setup(props, context) {
    const { onDeleteSchedule, onDeleteScheduleSuccess, loading, error } = useScheduleStore();

    /**
     * Confirmation dialoge
     */

    // confirmation diaglog visibility
    const deleteConfirmationVisible = ref(false);
    const onClickDelete = () => {
      deleteConfirmationVisible.value = true;
    };

    // confirmation dialog message
    const header = computed(() => `Delete ${props.schedule.name}`);
    const message = `Are you really sure you want to delete ${props.schedule.name} and all related shifts and demands? This action can't be undone.`;

    /**
     * Confirmation dialoge actions
     */

    const onConfirmDelete = () => {
      onDeleteSchedule(props.schedule.id);
    };

    const onCancelDelete = () => {
      deleteConfirmationVisible.value = false;
      context.emit("canceled");
    };

    onDeleteScheduleSuccess(() => {
      deleteConfirmationVisible.value = false;
      context.emit("deleted");
      console.info("Schedule deleted");
    });

    return {
      header,
      message,
      onClickDelete,
      deleteConfirmationVisible,
      loading,
      error,
      onConfirmDelete,
      onCancelDelete
    };
  }
});
